module.exports = __webpack_public_path__ + "img/Copy.f33a09c9.svg";